import { useParams } from "react-router-dom";

import MainPage from "../../components/Pages/MainPage";
import NotFound from "../../components/Pages/NotFound";
import LeftMenu from "../../components/LeftMenu";
import CompaniesPage from "../../components/Pages/CompaniesPage";
import OffersPage from "../../components/Pages/OffersPage";
import ProjectsPage from "../../components/Pages/ProjectsPage";
import TestOffersPage from "../../components/Pages/TestOffersPage";
import ReplaceDataPage from "../../components/Pages/ReplaceDataPage";
import TestSitePage from "../../components/Pages/TestSitePage";
import SortPage from "../../components/Pages/SortPage";
import ActivatePage from "../../components/Pages/ActivatePage";
import BucketsGetPage from "../../components/Pages/Buckets/BucketsGetPage";
import BucketsAddPage from "../../components/Pages/Buckets/BucketsAddPage";

import UnloadPromo from "../../components/Pages/Unload/UnloadPromo";
import UnloadLeads from "../../components/Pages/Unload/UnloadLeads";
import UnloadTotal from "../../components/Pages/Unload/UnloadTotal";
import UploadedActivations from "../../components/Pages/UploadedActivations";

import PositionCalculator from "../../components/Pages/PositionCalculator";

import { useLayoutEffect } from "react";
import { pageTitles } from "@content";

import "./style.scss";
import RangingPage from "../../components/Pages/RangingPage";
import Lego from "../../components/Pages/Lego";

const Pages = () => {
    const { firstParam } = useParams();

    let pageType = firstParam ? firstParam : "main";

    let Specified = pages[pageType] ? pages[pageType] : pages["not-found"];

    useLayoutEffect(() => {
        document.title = pageTitles[pageType];
    }, [pageType]);

    return (
        <div className="pages">
            <LeftMenu />
            <div className={`pages__block ${pageType}`}>
                <Specified />
            </div>
        </div>
    );
};

export default Pages;

const pages = {
    main: MainPage,
    companies: CompaniesPage,
    offers: OffersPage,
    projects: ProjectsPage,
    "not-found": NotFound,
    "buckets-add": BucketsAddPage,
    "buckets-get": BucketsGetPage,
    "test-offer": TestOffersPage,
    "replace-data": ReplaceDataPage,
    "test-site": TestSitePage,
    sort: SortPage,
    activate: ActivatePage,
    "uploaded-activations": UploadedActivations,
    "unload-promo": UnloadPromo,
    "unload-leads": UnloadLeads,
    "unload-total": UnloadTotal,
    "position-calculator": PositionCalculator,
    ranging: RangingPage,
    lego: Lego,
};
